module.exports = __webpack_public_path__ + "static/media/combo_ride_7.94f03a46.png";